import React from 'react';
import './paymentTypeSwitcher.scss';
import { useDispatch, useSelector } from 'react-redux';
import { setPayByCard } from '../../../redux/actions';
import { useContent, useLanguages } from '../../../hooks/content';
import { Returntext } from '../../../pages/Landings/common/returnText';

const PaymentTypeSwitcher = () => {
  const payByCard = useSelector((state) => state.payByCard);
  const dispatch = useDispatch();

  const togglePaymentMethod = (value) => {
    dispatch(setPayByCard(value)); // Toggle the payment method
  };

  const { lang } = useLanguages();
  const { contentManagementData } = useContent();

  return (
    <div className="payment-type-switcher">
      <div
        className={`switch-btn ${payByCard && 'active'}`}
        onClick={() => {
          togglePaymentMethod(true);
        }}
      >
        {Returntext(contentManagementData, 'pay_by_card', lang)}{' '}
      </div>
      <div
        className={`switch-btn ${!payByCard && 'active'}`}
        onClick={() => {
          togglePaymentMethod(false);
        }}
      >
        {Returntext(contentManagementData, 'pay_via_bank', lang)}{' '}
      </div>
    </div>
  );
};

export default PaymentTypeSwitcher;
